"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { shadcn } from "@clerk/themes";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { ConvexClientProvider } from "./convex-client-provider";
import { ThemeProvider } from "./theme-provider";
import { Toaster } from "./ui/sonner";
import { UsernameCheckProvider } from "./username-check-provider";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ClerkProvider afterSignOutUrl="/" appearance={{ theme: shadcn }} dynamic>
      <ConvexClientProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="dark"
          disableTransitionOnChange
          enableSystem
        >
          <UsernameCheckProvider>
            <NuqsAdapter>
              {children}
              <Toaster richColors />
            </NuqsAdapter>
          </UsernameCheckProvider>
        </ThemeProvider>
      </ConvexClientProvider>
    </ClerkProvider>
  );
}
